import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { getPost } from '../api/posts';
import BlogPostContent from '../components/BlogPostContent';
import PostMarginalia from '../components/PostMarginalia';
import StatusMessage from '../components/StatusMessage';

const BlogPostPage: React.FC = () => {
  const { id } = useParams();
  const postQuery = useQuery({
    queryKey: ['posts', 'detail', id],
    queryFn: () => getPost(id!),
    enabled: Boolean(id),
  });

  if (postQuery.isLoading) {
    return <StatusMessage type="loading" className="pt-24" />;
  }

  if (postQuery.error) {
    return (
      <StatusMessage
        type="error"
        message={postQuery.error instanceof Error ? postQuery.error.message : 'Failed to fetch post.'}
        className="mx-auto mt-24 max-w-4xl"
      />
    );
  }

  const post = postQuery.data;
  if (!post) {
    return null;
  }

  return (
    <BlogPostContent title={post.title} content={post.content} publishedAt={post.published_at}>
      <PostMarginalia postId={post.id} postAuthorId={post.author_id} />
    </BlogPostContent>
  );
};

export default BlogPostPage;
